import { Injectable } from '@angular/core';
import { IDeviceStatusViewInfo } from '../models/device-status-view-info.interface';
import { DeviceStatusType } from '../models/device-status-type.interface';

@Injectable({
    providedIn: 'root'
})
export class DeviceStatusViewInfoService {
    public static $name = 'deviceStatusViewInfoService';

    // default values
    private readonly DEFAULT_SIZE: number = 24;
    private readonly NOTRESPONDING_SIZE: number = 20;
    private readonly DEFAULT_ICON: string = 'fiber_manual_record';
    private readonly ALTERNATIVE_ICON: string = 'wifi';
    private readonly ERROR_ICON: string = 'error_outline';

    public getState(
        deviceStatusType: DeviceStatusType,
        alternativeIcon: boolean): IDeviceStatusViewInfo {
        const statusType = {} as IDeviceStatusViewInfo;
        statusType.size = this.DEFAULT_SIZE;
        statusType.icon = alternativeIcon ? this.ALTERNATIVE_ICON : this.DEFAULT_ICON;

        switch (deviceStatusType) {
            case DeviceStatusType.InActive:
                statusType.cls = 'device-status-inactive';
                statusType.statusDescription = 'Inactive';
                break;

            case DeviceStatusType.Stale:
                statusType.cls = 'device-status-stale';
                statusType.statusDescription = 'Stale';
                break;

            case DeviceStatusType.Active:
                statusType.cls = 'device-status-active';
                statusType.statusDescription = 'Active';
                break;

            case DeviceStatusType.NotResponding:
                statusType.cls = 'device-status-notresponding';
                statusType.statusDescription = 'Not responding';
                statusType.icon = 'cancel';
                statusType.size = this.NOTRESPONDING_SIZE;
                break;

            case DeviceStatusType.DuplicateModbusId:
                statusType.cls = 'device-status-notresponding';
                statusType.statusDescription = 'Duplicate Modbus Id';
                statusType.icon = this.ERROR_ICON;
                break;

            case DeviceStatusType.Failure:
                statusType.cls = 'device-status-failure';
                statusType.statusDescription = 'Reader Failure';
                statusType.icon = 'cancel';
                break;
        }

        return statusType;
    }
}
